import { API_BASE_URL } from "../config/api";

export const resolveImageUrl = (imagePath) => {
  if (!imagePath || typeof imagePath !== "string") return "";

  if (/^(https?:\/\/|data:image\/|blob:)/i.test(imagePath)) {
    return imagePath;
  }

  return `${API_BASE_URL}${imagePath.startsWith("/") ? imagePath : `/${imagePath}`}`;
};
